import axios from 'axios';
import Swal from 'sweetalert2';
import { API_BASE_URL } from '../config';

// 1. Cria a instância principal do Axios
const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
});

// 2. Interceptor de REQUISIÇÃO (Adiciona o token em todas as chamadas)
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 3. Interceptor de RESPOSTA (Trata expiração de sessão / 401)
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('authenticated');
      localStorage.removeItem('tipo_usuario');
      localStorage.removeItem('username');
      localStorage.removeItem('foto_perfil_url');
      localStorage.removeItem('lastLoginTime');

      window.dispatchEvent(new Event('storage-logout'));

      Swal.fire({
        title: 'Sessão Encerrada',
        text: 'Sua sessão foi desconectada ou expirou. Você será redirecionado para a tela de login.',
        icon: 'warning',
        confirmButtonColor: '#16a34a',
        allowOutsideClick: false,
      }).then(() => {
        window.location.href = '/login';
      });
    }

    return Promise.reject(error);
  }
);

export default api;
